/** Kitchen touch monitor — FR / AR */
export const cuisinePageFr = {
  title: 'Moniteur cuisine',
  hint: 'Cuisine seule sur le 2ᵉ moniteur — la caisse reste sur l’écran principal.',
  empty: 'Aucune commande cuisine',
  sectionTable: 'Sur place',
  sectionEmporter: 'Emporter',
  sectionDelivery: 'Livraison',
  sectionEmpty: 'Rien pour l’instant',
  channelTable: 'Table',
  channelEmporter: 'Emporter',
  channelDelivery: 'Livraison',
  tableTitle: 'Table {{label}}',
  emporterTitle: 'Emporter',
  deliveryTitle: 'Livraison',
  deliveryTitlePhone: 'Livraison · {{phone}}',
  covers: '{{count}} couverts',
  noteLabel: 'Note',
  status_sent: 'En cuisine',
  status_preparing: 'En préparation',
  status_ready: 'Prêt',
  markPreparing: 'En prep.',
  markReady: 'Prêt',
  markServed: 'Servi',
  soundOn: 'Son',
  soundOff: 'Muet',
  soundMute: 'Couper les sons cuisine',
  soundUnmute: 'Activer les sons cuisine',
  soundVolume: 'Volume',
  releaseSecondScreen: 'Partager 2ᵉ écran',
  releaseSecondScreenTitle:
    'Affiche uniquement la cuisine sur le 2ᵉ moniteur (HDMI / écran sans fil) — pas tout le bureau',
  enterFullscreen: 'Plein écran',
  exitFullscreen: 'Quitter plein écran',
  backToPos: 'Caisse',
  backToPosTitle: 'Retour à la caisse',
  releaseOkSecond: 'Cuisine partagée sur le 2ᵉ écran.',
  releaseOkPopup:
    'Fenêtre cuisine ouverte — placez-la sur le 2ᵉ moniteur si besoin, puis plein écran.',
  releaseBlocked: 'Impossible d’ouvrir la fenêtre — autorisez les pop-ups pour AMAN.',
  ajoutBanner: 'AJOUT',
  ajoutExplain: 'Complément seulement — ne pas refaire toute la commande',
  commandeBanner: 'NOUVELLE COMMANDE',
  sectionLatest: 'À FAIRE MAINTENANT',
  sectionPrevious: 'Déjà envoyé',
  sectionPreviousNote: 'Ne pas refaire ces lignes — elles sont déjà en cuisine',
  lineKindNew: 'NOUVELLE LIGNE',
  lineNewExplain: 'Uniquement cet ajout — pas un renvoi de toute la commande'
};

export const cuisinePageAr = {
  title: 'شاشة المطبخ',
  hint: 'المطبخ فقط على الشاشة الثانية — الصندوق يبقى على الشاشة الرئيسية.',
  empty: 'لا طلبات للمطبخ',
  sectionTable: 'في المكان',
  sectionEmporter: 'للأخذ',
  sectionDelivery: 'توصيل',
  sectionEmpty: 'لا شيء حالياً',
  channelTable: 'طاولة',
  channelEmporter: 'للأخذ',
  channelDelivery: 'توصيل',
  tableTitle: 'طاولة {{label}}',
  emporterTitle: 'للأخذ',
  deliveryTitle: 'توصيل',
  deliveryTitlePhone: 'توصيل · {{phone}}',
  covers: '{{count}} أشخاص',
  noteLabel: 'ملاحظة',
  status_sent: 'في المطبخ',
  status_preparing: 'قيد التحضير',
  status_ready: 'جاهز',
  markPreparing: 'تحضير',
  markReady: 'جاهز',
  markServed: 'تم التقديم',
  soundOn: 'صوت',
  soundOff: 'صامت',
  soundMute: 'كتم أصوات المطبخ',
  soundUnmute: 'تفعيل أصوات المطبخ',
  soundVolume: 'مستوى الصوت',
  releaseSecondScreen: 'مشاركة الشاشة الثانية',
  releaseSecondScreenTitle:
    'عرض المطبخ فقط على الشاشة الثانية (HDMI / لاسلكي) — وليس سطح المكتب كله',
  enterFullscreen: 'ملء الشاشة',
  exitFullscreen: 'إنهاء ملء الشاشة',
  backToPos: 'الصندوق',
  backToPosTitle: 'العودة إلى الصندوق',
  releaseOkSecond: 'تم مشاركة المطبخ على الشاشة الثانية.',
  releaseOkPopup: 'نافذة المطبخ مفتوحة — انقلها إلى الشاشة الثانية إن لزم ثم ملء الشاشة.',
  releaseBlocked: 'تعذر فتح النافذة — اسمح بالنوافذ المنبثقة لـ AMAN.',
  ajoutBanner: 'إضافة',
  ajoutExplain: 'تكملة فقط — لا تعِد تحضير الطلب كاملاً',
  commandeBanner: 'طلب جديد',
  sectionLatest: 'حضّر الآن',
  sectionPrevious: 'سبق إرساله',
  sectionPreviousNote: 'لا تُعِد هذه البنود — هي بالفعل في المطبخ',
  lineKindNew: 'سطر جديد',
  lineNewExplain: 'هذه الإضافة فقط — وليس إعادة إرسال الطلب كاملاً'
};
